
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cdmx",
      function () {
        return require("private-next-pages/cdmx/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cdmx"])
      });
    }
  